import React from 'react';
import {
  u2106QuotaBarFillClass,
  u2106QuotaBarWidthPercent,
  type U2106QuotaBarTone,
} from '../tools/U2106AiUsageFormatters';

interface U2106QuotaBarProps {
  usagePercent: number | null;
  tone: U2106QuotaBarTone;
  label?: string;
}

/**
 * Jauge de quota U2106 — masquée si illimité (tone unlimited / percent null).
 */
const U2106QuotaBar: React.FC<U2106QuotaBarProps> = ({ usagePercent, tone, label }) => {
  if (tone === 'unlimited' || usagePercent == null) {
    return null;
  }

  const width = u2106QuotaBarWidthPercent(usagePercent);
  const fillClass = u2106QuotaBarFillClass(tone);

  return (
    <div className="mt-2">
      {label ? <p className="mb-1 text-xs text-gray-500">{label}</p> : null}
      <div className="h-2 w-full overflow-hidden rounded-sm bg-gray-200">
        <div
          className={`h-full rounded-sm transition-[width] ${fillClass}`}
          style={{ width: `${width}%` }}
          role="progressbar"
          aria-valuenow={Math.round(width)}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};

export default U2106QuotaBar;
